<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados da empresa'" :TipoCliente="'Fundos'"
                        :Sessao="'Dados Cadastrais'" :SubSessao="'Dados da Empresa'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="razaoSocial">Razão social*</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="localFI.RazaoSocial"
                                type="text" id="razaoSocial" disabled="true" placeholder="Empresa X LTDA">
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" id="cnpj" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.Cnpj" disabled="true" placeholder="12.345.678/0001-10">
                        </div>
                        <div class="label__field" style="width: 20%" v-if="configuracaoApelido == 'S'">
                            <div style="display: flex;">
                                <label class="label" for="apelido">Apelido*</label>
                                <i class="fa fa-info-circle info-icon"
                                    title="O apelido deve ter entre 3 e 20 caracteres, podendo incluir letras (maiúsculas ou minúsculas) e números. Não é permitido o uso de caracteres especiais."></i>
                            </div>
                            <input class="field" type="text" id="apelido" v-model="localFI.Apelido"
                                @input="validarApelido" @blur="checkApelidoLength" @change="salvarAlteracoesLocalmente">
                            <p v-if="apelidoError" class="erro">{{ apelidoError }}</p>
                            <p v-if="camposObrigatorios.erroApelido" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="RamoAtividade">Ramo de atividade*</label>
                            <select id="atividadePrincipal" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localFI.RamoAtividade">
                                <option v-for="(item) in listaAtividades" :key="item.id" :value="item.id">
                                    {{ item.descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroRamoAtividade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="dataConstituicao">Data de constituição*</label>
                            <input class="field" disabled="true" type="field" id="nome" 
                                v-model="localFI.DataConstituicaoFormatada" placeholder="00/00/0000"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Pessoa Contato</label>
                            <input class="field" type="text" id="pessoaContato" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.PessoaContato">
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Cargo</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.Cargo" id="cargo">
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Telefone*</label>
                            <input class="field" type="text" id="telefone" v-mask="celularMask"
                                @change="salvarAlteracoesLocalmente" v-model="localFI.Telefone"
                                placeholder="(00) 0000-0000">
                            <p v-if="camposObrigatorios.erroTelefone" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">E-mail*</label>
                            <input class="field" type="text" @blur="validarEmail" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.Email" id="Email">
                             <p v-if="emailErros.Email" class="erro">{{ emailErros.Email }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Endereço comercial'" :TipoCliente="'Fundos'"
                        :Sessao="'Dados Cadastrais'" :SubSessao="'Endereço Comercial'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente; validarCep(localFI)"
                                v-model="localFI.Cep" id="nome" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoCep" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="custom-link" style="width: 8%; margin-top: 35px;">
                            <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Endereço*</label>
                            <input class="field" type="text" id="nome" :disabled="isDisabledEnderecoLogradouro"
                                @change="salvarAlteracoesLocalmente" v-model="localFI.Logradouro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoLogradouro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">Número*</label>
                            <input class="field" type="text" id="nome" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.LogradouroNumero" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoNumero" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" id="nome" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.LogradouroComplemento" placeholder="">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Bairro*</label>
                            <input class="field" type="text" id="nome" :disabled="isDisabledEndereco"
                                @change="salvarAlteracoesLocalmente" v-model="localFI.Bairro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoBairro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Cidade*</label>
                            <input class="field" type="text" :disabled="isDisabledEndereco" v-model="localFI.Cidade"
                                @change="salvarAlteracoesLocalmente" id="cidade" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoCidade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">UF*</label>
                            <select class="field" :disabled="isDisabledEndereco" id="uf" v-model="localFI.Uf" @change="salvarAlteracoesLocalmente">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoUf" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">País*</label>
                            <select id="Pais" @change="salvarAlteracoesLocalmente" class="field" v-model="localFI.Pais"
                                :disabled="isDisabledEndereco">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Emitir Extrato em Papel*</label>
                            <div class="radio">
                                <input type="radio" id="EmitirExtratoPapel_Sim" value="true" name="EmitirExtratoPapel"
                                    class="field__radio" v-model="localFI.EmitirExtratoPapel"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="EmitirExtratoPapel_Sim" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="EmitirExtratoPapel_Nao" value="false" name="EmitirExtratoPapel"
                                    class="field__radio" v-model="localFI.EmitirExtratoPapel"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="EmitirExtratoPapel_Nao" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                        <div class="label__field" style="width: 50%">
                            <label class="label" for="nome">Esse endereço é o mesmo da correspondência?*</label>
                            <div class="radio">
                                <input type="radio" id="EnderecoCorrespondencia_Outro" value="1"
                                    name="EnderecoCorrespondencia" class="field__radio"
                                    v-model="localFI.EnderecoCorrespondencia"
                                    @change="limparCamposEnderecoCorrespondencia" />
                                <label for="EnderecoCorrespondencia_Outro" class="label__radio">
                                    Sim
                                </label>
                                <input type="radio" id="EnderecoCorrespondencia_Mesmo" value="2"
                                    name="EnderecoCorrespondencia" class="field__radio"
                                    v-model="localFI.EnderecoCorrespondencia"
                                    @change="limparCamposEnderecoCorrespondencia" />
                                <label for="EnderecoCorrespondencia_Mesmo" class="label__radio">
                                    Não
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario" v-if="localFI.EnderecoCorrespondencia == 2">
                <div class="categoriaAgrupamentoFormulario">
                    <h5>Endereço correspondência</h5>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text"
                                @change="salvarAlteracoesLocalmente; validarCepOutro(localFI)"
                                v-model="localFI.CepOutro" id="nome" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroCep" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 8%; margin-top: 35px;">
                            <a class="custom-link" target="_blank"
                                href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não
                                sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Endereço*</label>
                            <input class="field" type="text" id="nome" :disabled="isDisabledEnderecoOutroLogradouro"
                                @change="salvarAlteracoesLocalmente" v-model="localFI.LogradouroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroLogradouro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">Número*</label>
                            <input class="field" type="text" id="nome" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.LogradouroNumeroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroNumero" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 47%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" id="nome" @change="salvarAlteracoesLocalmente"
                                v-model="localFI.LogradouroComplementoOutro" placeholder="">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="nome">Bairro*</label>
                            <input class="field" type="text" id="nome" :disabled="isDisabledEnderecoOutro"
                                @change="salvarAlteracoesLocalmente" v-model="localFI.BairroOutro" placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroBairro" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">Cidade*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoOutro"
                                @change="salvarAlteracoesLocalmente" v-model="localFI.CidadeOutro" id="cidadeOutro"
                                placeholder="">
                            <p v-if="camposObrigatorios.erroEnderecoOutroCidade" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">UF*</label>
                            <select class="field"  :disabled="isDisabledEnderecoOutro" id="uf" v-model="localFI.UfOutro" @change="salvarAlteracoesLocalmente">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoOutroUf" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 25%">
                            <label class="label" for="nome">País*</label>
                            <select id="PaisOutro" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localFI.PaisOutro" :disabled="isDisabledEnderecoOutro">
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEnderecoOutroPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
import { validarCampoCep, ufs } from '@/utils/formUtils';
export default {
    name: 'CadastroOutros_DadosEmpresa',
    props: ['Edicao'],
    mixins: [emailValidatorMixin],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            infoEmpresa: 'GET_FI_INFO_EMPRESA',
            listaAtividades: 'GET_LISTA_ATIVIDADES',
            configuracoes: 'GET_CONFIGURACAO',
            listaPaises: 'GET_LISTA_PAISES',
        }),
        celularMask() {
            const telefoneLimpo = this.localFI.Telefone?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            isDisabledEndereco: false,
            emailErros: {},
            isDisabledEnderecoOutro: false,
            isDisabledEnderecoLogradouro: false,
            isDisabledEnderecoOutroLogradouro: false,
            camposObrigatorios: {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
            },
            permitirAvancar: false,
            localFI: {
                RazaoSocial: null,
                Cnpj: null,
                Apelido: null,
                ClienteId: null,
                RamoAtividade: null,
                DataConstituicao: null,
                PessoaContato: null,
                Cargo: null,
                Email: null,
                Telefone: null,
                Logradouro: null,
                LogradouroNumero: null,
                LogradouroComplemento: null,
                Bairro: null,
                Cidade: null,
                Uf: null,
                Pais: null,
                Cep: null,
                LogradouroOutro: null,
                LogradouroNumeroOutro: null,
                LogradouroComplementoOutro: null,
                BairroOutro: null,
                CidadeOutro: null,
                UfOutro: null,
                PaisOutro: null,
                CepOutro: null,
                EmitirExtratoPapel: false,
                EnderecoCorrespondencia: '1'
            },
            apelidoError: '',
            configuracaoApelido: ''
        }
    },
    mounted() {
        this.localFI = this.infoEmpresa;
        if (this.infoEmpresa != null && this.infoEmpresa.DataConstituicao != null) {
            this.localFI.DataConstituicao = this.converterData(this.infoEmpresa.DataConstituicao)
        }
        if (this.localFI != null) {
            this.localFI.EnderecoCorrespondencia = this.infoEmpresa.CepOutro != '' && this.infoEmpresa.CepOutro != null ? 2 : 1;
        }
        this.validarFormulario();
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACAO'
        }),
        validarEmail() {
            this.validarEmailGeneric(this.localFI.Email, 'Email', {
                obrigatorio: true,
            });
        },
        converterData(dataString) {
            if (dataString && dataString !== '0001-01-01T00:00:00') {
                let data = new Date(dataString);
                let ano = data.getFullYear();
                let mes = (data.getMonth() + 1).toString().padStart(2, '0');
                let dia = data.getDate().toString().padStart(2, '0');
                return `${ano}-${mes}-${dia}`;
            } else {
                return null;
            }
        },
        validarApelido(event) {
            if (this.configuracaoApelido === 'S') {
                const value = event.target.value;
                const regex = /[^a-zA-Z0-9]/g;
                this.localFI.Apelido = value.replace(regex, '').slice(0, 20);
            }
        },
        checkApelidoLength(event) {
            if (!this.localFI.Apelido || this.localFI.Apelido.length < 3) {
                this.apelidoError = 'O campo apelido deve ter no mínimo três caracteres.';
                event.target.focus();
            } else {
                this.apelidoError = '';
            }
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 1);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroEnderecoCep: false,
                erroEnderecoLogradouro: false,
                erroEnderecoNumero: false,
                erroEnderecoBairro: false,
                erroEnderecoCidade: false,
                erroEnderecoUf: false,
                erroEnderecoPais: false,
                erroEnderecoOutroCep: false,
                erroEnderecoOutroLogradouro: false,
                erroEnderecoOutroNumero: false,
                erroEnderecoOutroBairro: false,
                erroEnderecoOutroCidade: false,
                erroEnderecoOutroUf: false,
                erroEnderecoOutroPais: false,
            };
            if (!this.localFI.Apelido && this.configuracaoApelido === 'S') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroApelido = true;
                    nomeDoCampo = 'Apelido';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.RamoAtividade) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroRamoAtividade = true;
                    nomeDoCampo = 'Ramo da Atividade';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Telefone) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTelefone = true;
                    nomeDoCampo = 'Telefone';
                }
                this.permitirAvancar = false;
            }
            if (Object.values(this.emailErros).some(erro => erro !== '')) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEmail = true;
                    nomeDoCampo = 'E-mail';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Cep) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoCep = true;
                    nomeDoCampo = 'CEP do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Logradouro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.LogradouroNumero) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoNumero = true;
                    nomeDoCampo = 'Número do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Bairro) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoBairro = true;
                    nomeDoCampo = 'Bairro do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Cidade) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoCidade = true;
                    nomeDoCampo = 'Cidade do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Uf) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoUf = true;
                    nomeDoCampo = 'Uf do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.Pais) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoPais = true;
                    nomeDoCampo = 'País do Endereço Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroCep = true;
                    nomeDoCampo = 'CEP do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.LogradouroOutro && (this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroLogradouro = true;
                    nomeDoCampo = 'Logradouro do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.LogradouroNumeroOutro && (this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroNumero = true;
                    nomeDoCampo = 'Número do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.BairroOutro && (this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroBairro = true;
                    nomeDoCampo = 'Bairro do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.CidadeOutro && (this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroCidade = true;
                    nomeDoCampo = 'Cidade do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.UfOutro && (this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroUf = true;
                    nomeDoCampo = 'Uf do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (!this.localFI.PaisOutro && (this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2)) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEnderecoOutroPais = true;
                    nomeDoCampo = 'País do Endereço de Correspondência';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado ou é inválido, preencha a informação para avançar.`,
                });
            }
        },
        salvarInformacoes() {
            this.validarApelido({ target: { value: this.localFI.Apelido } });
            if (this.apelidoError) {
                return false;
            }
            this.$store.commit('SET_FI_SALVAR_INFO_BASICAS', this.localFI);
            this.$store.commit('SET_FI_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_FI_SALVAR_INFO_BASICAS', this.localFI);
            this.validarFormulario();
        },
        async validarCep(objDados, somenteValidar = false) {
            if (objDados.Cep) {
                var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar });
                if (result) {
                    this.isDisabledEndereco = true;
                    this.isDisabledEnderecoLogradouro = true;
                    if (objDados.Logradouro == '') {
                        this.isDisabledEnderecoLogradouro = false;
                    }
                } else {
                    this.isDisabledEndereco = false;
                    this.isDisabledEnderecoLogradouro = false;
                }
            }
        },
        async validarCepOutro(objDados, somenteValidar = false) {
            if (objDados.CepOutro) {
                var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar, tipoEndereco: "Outro" });
                if (result) {
                    this.isDisabledEnderecoOutro = true;
                    this.isDisabledEnderecoOutroLogradouro = true;
                    if (objDados.LogradouroOutro == '')
                        this.isDisabledEnderecoOutroLogradouro = false;
                } else {
                    this.isDisabledEnderecoOutro = false;
                    this.isDisabledEnderecoOutroLogradouro = false;
                }
            }
        },
        limparCamposEnderecoCorrespondencia() {
            this.localFI.LogradouroOutro = null;
            this.localFI.BairroOutro = null;
            this.localFI.CidadeOutro = null;
            this.localFI.UfOutro = null;
            this.localFI.PaisOutro = null;
            this.localFI.CepOutro = null;
            this.salvarAlteracoesLocalmente();
        },        
    },
    created() {
        this.fetchConfiguracao('EXIBIR APELIDO');
    },
    watch: {
        'localFI.Cep'(newCep) {
            if (newCep) {
                this.validarCep(this.localFI, true);
                if (this.localFI.EnderecoCorrespondencia == 2) { this.validarCepOutro(this.localFI, true); }
            }
        },
        infoEmpresa() {
            this.localFI = this.infoEmpresa;
            if (this.infoEmpresa != null && this.infoEmpresa.DataConstituicao != null) {
                this.localFI.DataConstituicao = this.converterData(this.infoEmpresa.DataConstituicao)
            }
        },
        configuracoes(newVal) {
            if (newVal && newVal.Valor) {
                this.configuracaoApelido = newVal.Valor;
            } else {
                console.error('Configurações não são válidas:', newVal);
                this.configuracaoApelido = [];
            }
        }
    },
}
</script>

<!--<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');


.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    border-bottom: 1px solid #D0D5DD;
    /* Borda */
}

.categoriaAgrupamentoFormulario {
    width: 10%;
    margin-right: 15px;

    h5 {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
    }

}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }




    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }

}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>-->